module.exports = __webpack_public_path__ + "static/emm-006-4a48bb715c1a5f55bcc8e7e8b9a6da48.jpg";